import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../../Translations';
import Popover from '../../../Popover';
import { ExperienceResource } from '../../Types';
import AdvancedLeaderProgram from './AdvancedLeaderProgram';
import AppliedExperiencePlatform from './AppliedExperiencePlatform';
import Coaching from './Coaching';
import PopoverContent from './PopoverContent';
import UnlicensedIcon from './UnlicensedIcon';

export interface Props {
  resource: ExperienceResource;
}

const OfferingType: React.FC<Props> = ({ resource }) => {
  switch (resource.payload.offeringType) {
    case 'aep':
      return (
        <Popover
          icon={
            <AppliedExperiencePlatform>
              <UnlicensedIcon payload={resource.payload} />
            </AppliedExperiencePlatform>
          }
          content={
            <PopoverContent
              content={
                <div className="bg-gray-700 text-white">
                  <T kind="Built for busy leaders, our library..." />
                </div>
              }
            />
          }
        />
      );
    case 'epc':
      return (
        <Popover
          icon={
            <AdvancedLeaderProgram>
              <UnlicensedIcon payload={resource.payload} />
            </AdvancedLeaderProgram>
          }
          content={
            <PopoverContent
              content={
                <div className="bg-gray-700 text-white">
                  <T kind="Bring the best of business school..." />
                </div>
              }
            />
          }
        />
      );
    case 'coaching':
      return (
        <Popover
          icon={
            <Coaching>
              <UnlicensedIcon payload={resource.payload} />
            </Coaching>
          }
          content={
            <PopoverContent
              content={
                <div className="bg-gray-700 text-white">
                  <T kind="For leaders that would benefit from having a personal guide ..." />
                </div>
              }
              pointerStyle="left-10 top-[-7px]"
            />
          }
        />
      );
    case 'group-coaching':
    case 'program-sequence':
      return <></>;
  }
};

export default observer(OfferingType);
